import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
//Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import InfoOutlined from "@material-ui/icons/InfoOutlined"; //Limitless imports

import SystemDialogue from "../system-dialogue/SystemDialogue";
import { log as pilog } from "../../../../common/utils/Logging";

var SystemExpiryDialogue = function SystemExpiryDialogue(_ref) {
  var classes = _ref.classes,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["classes", "theme"]);

  var Icon = /*#__PURE__*/React.createElement(InfoOutlined, {
    className: classes.primaryText
  });

  try {
    if (theme.palette.dialogues) {
      if (theme.palette.dialogues.expiry.iconUrl) {
        Icon = /*#__PURE__*/React.createElement("img", {
          src: theme.palette.dialogues.expiry.iconUrl
        });
      }

      if (theme.palette.dialogues.expiry.bodyClass) {
        classes.infoDialogueBody = theme.palette.dialogues.expiry.bodyClass;
      }

      if (theme.palette.dialogues.expiry.containerClass) {
        classes.infoDialogueContainer = theme.palette.dialogues.expiry.containerClass;
      }
    }
  } catch (error) {
    var log = pilog.getLogger("SystemExpiryDialogue");
    log.warn("Invalid theme object for ".concat(rest.dialogue.groupName));
  }

  return /*#__PURE__*/React.createElement(SystemDialogue, Object.assign({
    dialogueClasses: classes,
    Icon: Icon
  }, rest));
};

var styles = function styles(_ref2) {
  var palette = _ref2.palette;
  var expiryStyles = {
    primaryBackground: {
      backgroundColor: palette.contrast.main
    },
    primaryText: {
      color: palette.contrast.light
    }
  };

  try {
    expiryStyles.primaryBackground.backgroundColor = palette.dialogues.expiry.background;
    expiryStyles.primaryText.color = palette.dialogues.expiry.color;
  } catch (error) {
    var log = pilog.getLogger("SystemExpiryDialogue");
    log.info("Invalid theme object SystemExpiryDialogue");
  }

  return expiryStyles;
};

export default withStyles(styles, {
  withTheme: true
})(SystemExpiryDialogue);